export const ORGANIZATION_MESSAGES = {
    NOT_FOUND: '',SUCCESS: 'SUCCESS'
  };

  export const GET_ASYNC_JOBS_MESSAGES = {
    NOT_FOUND: 'No async jobs records were found',SUCCESS: 'SUCCESS'
  };
  export const DELETE_ASYNC_JOBS_MESSAGES = {
    SUCCESS: 'Mass Action was successfully deleted'
  };

  export const CREATE_ASYNC_JOB_MESSAGES = {
    SUCCESS: 'Mass Action was successfully created'
  };


// WEBPACK FOOTER //
// ./src/features/organization/constants/organizationMessages.js